import localForage from "localforage";
import { persistReducer, createMigrate } from "redux-persist";

//actions
import DatabaseActions from "./Database.actions";

//constants
import { CONFIG_MAP } from "Constants/Config";

//reducer
import DatabaseReducer from "./Database.reducer";

//sagas
import DatabaseSagas from "./Database.sagas";

const DatabasePersistConfig = {
	key: "Database",
	storage: localForage.createInstance({ name: "AppDatabase" }),
	timeout: null as unknown as undefined,
	// blacklist: ['weatherData'],
	version: 0,
	migrate: createMigrate({
		0: (state) => state,
	}),
};

export const initializeDatabase = (config: Record<keyof typeof CONFIG_MAP, boolean>) => {

	const modules: any = [{
		id: "Database",
		reducerMap: {
			//Auth: persistReducer(DatabasePersistConfig, DatabaseReducer),
			Database: DatabaseReducer,
		},
		sagas: [DatabaseSagas],
		initialActions: [DatabaseActions.INITIATE.action()],
		finalActions: [DatabaseActions.UNINITIATE.action()],
	}];

	return modules;
};
